export const initialState = {
	activitiesList: [],
	lockedActivitiesList: [],
	unlockedActivitiesList: [],
	readingList: [],
	activeActivityQuestionsList: []
};
